import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { HistogramData } from "../../api/client";

export interface HistogramChartProps {
  histogram: HistogramData | null | undefined;
  color?: string;
  height?: number;
}

interface HistogramDatum {
  bucket: string;
  count: number;
}

function buildData(histogram: HistogramData | null | undefined): HistogramDatum[] {
  if (!histogram) {
    return [];
  }

  const { bucket_counts: counts, explicit_bounds: bounds } = histogram;

  if (!counts || !Array.isArray(counts) || counts.length === 0) {
    return [];
  }

  if (!bounds || !Array.isArray(bounds)) {
    return [];
  }

  const data: HistogramDatum[] = [];

  for (let i = 0; i < counts.length; i += 1) {
    const lower = i === 0 ? 0 : (bounds[i - 1] ?? 0);
    const upper = bounds[i] ?? (bounds.length > 0 ? bounds[bounds.length - 1] : 0);
    data.push({
      bucket: `${lower.toFixed(2)}–${upper.toFixed(2)}`,
      count: counts[i] ?? 0,
    });
  }

  return data;
}

export function HistogramChart({
  histogram,
  color = "#22c55e",
  height = 200,
}: HistogramChartProps) {
  const data = buildData(histogram);

  if (data.length === 0) {
    return (
      <div
        style={{
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: 0.7,
        }}
      >
        Keine Histogramm-Daten verfügbar
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data}>
        <XAxis dataKey="bucket" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="count" fill={color} />
      </BarChart>
    </ResponsiveContainer>
  );
}
